import { render, staticRenderFns } from "./DeleteQuestion.vue?vue&type=template&id=275e8437&scoped=true&"
import script from "./DeleteQuestion.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DeleteQuestion.vue?vue&type=style&index=0&id=275e8437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e8437",
  null
  
)

export default component.exports